<template>
    <div v-cloak>
        <div
            v-for="(m, index) in events"
            :class="{
                'events-group': true,
                'current-item': m.is_current,
                'future-event': m.is_future_date
            }"
        >
            <div
                :id="getElementId(m)"
                :class="{
                    'events-group-header': true,
                    'is-current': m.is_current
                }"
            >
                <div class="events-group-header-icon">
                    <span>{{ getDate(index)[0] }}</span>
                </div>
                {{ getDate(index) }}
                <a v-if="m.is_current" href="javascript:{}">Scroll up for history</a>
            </div>
            <a
                @click="go_to_event(event)"
                class="events-group-item"
                v-if="m.events && m.events.length > 0"
                v-for="event in m.events"
            >
                <div class="events-group-item-header">
                    {{ event.name }}
                    <span v-if="get_deadline_items(event).length > 0" class="alert"></span>

                    <div
                        v-if="
                            event.tasks.length > 0 &&
                                !event.tasks.includes(event.tasks.find(el => el.status === 'in_progress'))
                        "
                        class="status success"
                    >
                        All done!
                    </div>
                    <div class="status" v-else>
                        Tasks: <span>{{ event.tasks.length }}</span>
                    </div>
                </div>
                <div class="events-group-item-content">
                    <div class="events-group-item-content--date" v-if="event.time">
                        {{ moment(event.time).format("dd")[0] }}
                        {{ moment(event.time).format("DD.MM, HH:mm") }}
                    </div>
                    <div
                        class="events-group-item-content--attending"
                        v-if="event.attendees_count && event.attendees_count > 0"
                    >
                        Attending {{ event.attending_attendees_count }}/{{ event.attendees_count }}
                    </div>
                </div>
            </a>
            <div v-if="m.events && m.events.length === 0">
                <div class="no-results">No results</div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
import router from "@/router";

export default {
    props: ["events", "i"],
    data() {
        return {};
    },
    computed: {
        ...mapState("StoreEvent", ["event"])
    },
    methods: {
        ...mapMutations("StoreEvent", ["set_active_event"]),

        getElementId(m) {
            return m.is_current ? "is-current" : "";
        },
        get_deadline_items(event) {
            if (event.tasks && event.tasks.length > 0) {
                return event.tasks.filter(item => {
                    return (
                        item.status === "in_progress" &&
                        item.deadline &&
                        moment(item.deadline).format("DD.MM") === moment(new Date()).format("DD.MM")
                    );
                });
            } else {
                return [];
            }
        },
        go_to_event(event) {
            if (event.reccured_item) {
                this.set_active_event(event);
            } else {
                this.set_active_event({});
            }
            router.push({ path: "/events/" + event.id });
        },
        getDate(date) {
            let time_date = moment(date, "MM.YYYY");
            return moment(time_date).format("MMMM YYYY");
        }
    }
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

.no-results {
    font-size: 1.1rem;
    line-height: 2rem;
    letter-spacing: 0.05em;
    color: #9d9d9d;
    padding-bottom: 1.2rem;
}
</style>
